import { createContext, useState } from 'react';
import api from 'services/api';

export const TipoVinculoContext = createContext();

export const TipoVinculoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [tipoVinculo, setTipoVinculo] = useState({
    data: [],
    colunas: [],
    filter: {},
    page: 0,
    size: 10,
  });

  const getTipoVinculo = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: tipoVinculo?.filter,
        page: tipoVinculo?.page,
        size: tipoVinculo?.size,
        order: tipoVinculo?.order,
        ...payload,
      });
      setTipoVinculo((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <TipoVinculoContext.Provider
      value={{
        getLoading,
        tipoVinculo,
        getTipoVinculo,
      }}
    >
      {children}
    </TipoVinculoContext.Provider>
  );
};
